<template>
  <div>
    <v-dialog
      v-model="showEscapeNotificationComputed"
      width="300">
      <v-card
        color="error"
        dark>
        <v-card-text>
          {{ $t('wdm.views.designPanel.errors.commandFailed', 'Command failed.') }}
          <br>
          {{ $t('wdm.views.designPanel.errors.unselectCurrentCell', 'Please unselect your current cell in Excel.') }}
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="sendingCommand"
      persistent
      width="300">
      <v-card>
        <v-card-text>
          <div class="logo-ctr">
            <div
              id="loading-date"
              class="loading-date">
              {{ lastTimer }}
            </div>
            <span class="circle circle-dark" />
            <span class="circle circle-dark-dashed" />
            <img
              class="circle wmimg"
              :src="require(`../assets/img/Platform-white.png`)">
          </div>
          <div class="busy-content">
            {{ busyContent }}
          </div>
          <div class="busy-content">
            {{ busyError }}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="!cancelDialog || !showCancel"
            @click="cancelDialog()"
            small
            outline>
            {{ $t('wdm.views.designPanel.labels.cancel', 'Cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <pop-up-error
      v-if="error"
      :model.sync="showErrorDialog"
      :error="error" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { CANCEL_TIMEOUT } from '../constants/office'

const defaultTimer = '0min : 0s : 0ms'

export default {
  data () {
    return {
      timer: null,
      tms: null,
      lastTimer: defaultTimer // code récupéré de v18 (cpas moi!)
    }
  },
  computed: {
    ...mapState('office', [
      'commandStep',
      'sendingCommand',
      'showEscapeNotification',
      'cancelDialog',
      'busyContent',
      'busyError'
    ]),
    ...mapState('wdm', [
      'error'
    ]),
    showErrorDialog: {
      get () {
        return this.error != null
      },
      set (value) {
        if (!value) {
          this.setError(null)
        }
      }
    },
    showCancel () {
      return this.tms != null && this.tms > CANCEL_TIMEOUT
    },
    showEscapeNotificationComputed: {
      get () {
        return this.showEscapeNotification
      },
      set (value) {
        this.toggleEscapeNotification(value)
      }
    }
  },
  methods: {
    ...mapActions('office', [
      'toggleEscapeNotification'
    ]),
    ...mapActions('wdm', [
      'setError'
    ]),
    startTime () {
      // code récupéré de v18 (cpas moi!)
      const d1 = new Date()
      this.timer = setInterval(() => {
        const d2 = new Date()
        this.tms = d2.getTime() - d1.getTime()
        this.lastTimer = parseInt(this.tms / (1000 * 60)) + 'min : ' + parseInt((this.tms / 1000) % 60) + 's : ' + parseInt((this.tms % 1000) / 100) + 'ms'
      }, 550)
    }
  },
  watch: {
    sendingCommand: {
      immediate: true,
      handler (sendingCommand) {
        if (sendingCommand) {
          this.startTime()
        } else {
          if (this.timer) {
            clearInterval(this.timer)
            this.timer = null
          }
          this.tms = null
          this.lastTimer = defaultTimer
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~common-assets/scss/we";
  .busy-content {
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    max-height: 65px;
  }
  .logo-ctr {
    position: relative;
    height: 250px;
    overflow: hidden;
  }
  .logo-ctr .circle {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
    bottom: 0;
  }

  .logo-ctr .circle-white {
    width: 300px;
    height: 300px;
    border: 4px dashed white;
    border-radius: 50%;
    animation-name: circle-white;
    animation-duration: 10s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-direction: reverse;
  }

  .logo-ctr .circle-dark {
    width: 200px;
    height: 200px;
    background-color: black;
    border-radius: 50%;
    z-index: 1000004;
  }

  .logo-ctr .circle-dark-dashed {
    border-radius: 50%;
    background-color: transparent;
    border: 5px dashed black;
    width: 210px;
    height: 210px;
    animation-name: circle-dark-ctr;
    animation-duration: 10s;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
    animation-direction: normal;
  }

  @keyframes circle-dark-ctr{
    0% {transform: rotate(0deg)}
    100% {transform: rotate(360deg)}
  }

  @-webkit-keyframes circle-dark-ctr{
    0% {transform: rotate(0deg)}
    100% {transform: rotate(360deg)}
  }

  .logo-ctr .wmimg {
    width: 140px;
    height: 140px;
    left:-5px;
    top:-10px;
    z-index: 1000005;
  }

  .logo-ctr .loading-date {
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    top: 0;
    bottom: -130px;
    width: 150px;
    height: 20px;
    font: bold 0.8rem arial,tahoma,sans-serif;
    text-align:center;
    color:white;
    z-index: 1000006;
  }
</style>
